import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { concatMap, map, of } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { ApplicationService } from '../service/application.service'
import { navigationUrlForApplications } from '../service/navigation-urls';
import {getUser, PortalHotToastService} from '@portal-workspace/grow-ui-library';
import {Priviledges} from '@portal-workspace/grow-shared-library';


export const applicationAccessGuard = () => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {

    const applicationService = inject(ApplicationService);
    const authService = inject(AuthService);
    const portalHotToastService = inject(PortalHotToastService);
    const router = inject(Router);

    const allowedUserPrivileges: Priviledges = ['admin', 'analyst', 'internalbroker','operations', 'operations24', 'credit','salesBDM' , 'salesAM']
    const applicationId = route.params.applicationId
    const currentUser = getUser();

    if (!currentUser) {
      return false;
    }

    if (currentUser.priviledges.some(r => allowedUserPrivileges.includes(r))) {
      return true
    }
    else {
      return applicationService.getApplicationById(applicationId).pipe(
        concatMap(application => {
          const app = application.payload;
          const applicationUserId = application.payload.UserId
          if (currentUser?.OriginatorBusinessId != null && currentUser.OriginatorBusinessId === app.OriginatorBusinessId) {
            return of(true)
          }
          else if (currentUser.priviledges.includes('companyadmin') || currentUser.priviledges.includes('companyoperator')) {
            return authService.getOriginatorBusinessIdsForUser(currentUser.UserId).pipe(
              map(userOriginatorBusinessIds => {
                if (app.OriginatorBusinessId != null && userOriginatorBusinessIds.payload.includes(app.OriginatorBusinessId)) {
                  return true
                }
                portalHotToastService.info(`Insufficient management access to application ${applicationId}`);
                return router.navigate(navigationUrlForApplications())
              }))
          }
          portalHotToastService.info(`Insufficient access to application ${applicationId}`);
          return of(router.navigate(navigationUrlForApplications()))
        })
      )
    }
  }
}



